'use client';

import { createTheme } from '@mui/material/styles';
import { Space_Grotesk } from 'next/font/google';

const spaceGrotesk = Space_Grotesk({
    style: 'normal',
    weight: '400',
    subsets: ['latin'],
    display: 'swap',
});

const theme = createTheme({
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                fullWidth: true,
            },
            styleOverrides: {
                root: {
                    paddingBottom: 14,
                    paddingTop: 14,
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: `
                body: {
                    line-height: normal;
                }
            `,
        },
        MuiTypography: {
            styleOverrides: {
                h4: {
                    fontSize: '24px',
                    fontWeight: 600,
                },
            },
        },
    },
    palette: {
        background: {
            default: '#F4F6F5',
        },
        primary: {
            contrastText: '#ffffff',
            main: '#00B579',
        },
    },
    shape: {
        borderRadius: 4, // defaults to 4
    },
    typography: {
        button: {
            textTransform: 'none',
        },
        fontFamily: spaceGrotesk.style.fontFamily,
    },
});

export default theme;
